export default __webpack_public_path__ + "static/media/OUWB.009ad9a3.jpeg";